import { useState } from "react"
import CallToAction from "./CallToAction"

const defaultState = {
  "automatic-payments": false,
  "refunds-and-overages": false,
  "prepayment-and-proration": false,
  "rollover-days": false,
  "loss-of-membership": false,
}

export default function MembershipForm({ smartSheetLink }) {
  const [checkedTerms, setCheckedTerms] = useState(defaultState)
  const allChecked = Object.values(checkedTerms).every(Boolean)

  const handleChange = (event) => {
    setCheckedTerms({ ...checkedTerms, [event.target.name]: event.target.checked })
  }

  const terms = [
    {
      label: "Automatic Payments",
      name: "automatic-payments",
    },
    { label: "Refunds and Overages", name: "refunds-and-overages" },
    { label: "Prepayment and Proration", name: "prepayment-and-proration" },
    { label: "Rollover Days", name: "rollover-days" },
    { label: "Loss of Membership", name: "loss-of-membership" },
  ]

  return (
    <>
      <form className="membership-form">
        {terms.map((term, idx) => (
          <div key={idx} className="py-1">
            <label>
              <input type="checkbox" name={term.name} checked={checkedTerms[term.name]} onChange={handleChange} />
              <span className="">{term.label}</span>
            </label>
          </div>
        ))}
      </form>

      <div className="lg:flex lg:mt-6 lg:justify-center lg:gap-10">
        <div className="my-6 lg:my-0">
          {allChecked ? (
            <CallToAction style="secondary" href={smartSheetLink}>
              I AGREE
            </CallToAction>
          ) : (
            <button
              type="button"
              disabled
              className="secondary-link inline-block  disabled:border-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed px-6 py-1.5 text-m1 sm:text-lg font-bold bg-white border-[3px] border-green-apple rounded-full no-underline uppercase hover:border-green-sea"
            >
              {""}I AGREE
            </button>
          )}
        </div>
        <div className="">
          <CallToAction style="secondary" href="#important-details">
            READ TERMS
          </CallToAction>
        </div>
      </div>
    </>
  )
}
